var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full"},[_c('PropagateLoader',{staticClass:"w-12 h-12 mx-auto py-10",attrs:{"loading":_vm.loading,"color":"#1E88E5","size":"20"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }